// extracted by mini-css-extract-plugin
module.exports = {"searchArea":"search_searchArea_2Y6Fy","mobileSearchBar":"search_mobileSearchBar_3qms-"};